// @ts-check

import { isImage } from '@/helpers/files'
import { useArrayFilter, useArrayFind, useArrayMap } from '@vueuse/core'
import * as _ from 'lodash-es'
import { api as viewerApi } from 'v-viewer'

/**
 * @param {import('vue').MaybeRefOrGetter<Attachments>} attachments
 */
export const useAttachments = (attachments) => {
  /**
   * Returns a displayable src for the given attachment.
   * @param {AttachmentResource} attachment
   */
  const getSrc = (attachment) =>
    attachment.file && attachment.mime_type
      ? `data:${attachment.mime_type};base64,${attachment.file}`
      : null

  const mainAttachment = useArrayFind(
    attachments,
    (attachment) => attachment.is_main
  )

  const imageAttachments = useArrayFilter(attachments, isImage)

  const images = useArrayMap(imageAttachments, (attachment) => ({
    id: attachment.id,
    src: getSrc(attachment),
    alt: attachment.original_file_name
  }))

  /**
   * @param {number?} initialId
   */
  const viewImages = (initialId) => {
    viewerApi({
      images: images.value,
      options: {
        scalable: false,
        inline: false,
        initialViewIndex: initialId
          ? _.findIndex(images.value, { id: initialId })
          : undefined
      }
    })
  }

  return {
    imageAttachments,
    mainAttachment,
    images,
    getSrc,
    viewImages
  }
}
